<div>
  <div class="hub-navbar" [ngClass]="{ shadow: showShadow }">
    <div class="nav-background">
      <div class="hub-navbutton">
        <i class="fa hubtiger-menu" (click)="menuOpen = !menuOpen" [ngClass]="{ rotate: !menuOpen }"></i>
      </div>

      <div class="partner-name">{{ partner.Name }}
        <span class="fa fa-caret-down" style="cursor: pointer"
              *ngIf="shops && shops.length > 1 && shops.length <= maxDropdownShops"
              (click)="shopDropMenuOpen = !shopDropMenuOpen">
                      <div class="menu-center">
                        <div style="margin-top: 16px;" class="menu-drop-down shop-menu-drop-down"
                             [ngClass]="{ 'shop-drop-menu-open drop-menu-open': !shopDropMenuOpen }">
                          <ul>
                            <li *ngFor="let shop of shops" (click)="selectShop(shop)">
                              {{shop.Name}}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </span>
      </div>

      <div class="menu-right">
        <div class="profile"
             (click)="openProfileMenu($event); notificationOpen = false; posSyncStatusOpen = false;">
          <avatar style="margin: auto;margin-right: 8px;" size="40"
                  name="{{ profile.Name === null && profile.Surname === null ?  'No Name' :  (profile.Name + ' ' + profile.Surname) }}"
                  profilePhoto="{{ profile.ImageURL }}"></avatar>
          <a
            href="javascript:void(0)">{{ profile.Name === null && profile.Surname === null ? 'No Name' : (profile.Name + ' ' + profile.Surname)}}</a>
        </div>
        <div #profileDropdownRef class="menu-drop-down" [ngClass]="{ 'drop-menu-open': !dropMenuOpen }">
          <ul>
            <li routerLink="/administration/stores" *ngIf="profile.IsSuperUser">
              <span class="fa fa-fw hubtiger-super-dash"></span>Super User Portal
            </li>
            <!-- <li routerLink="/clubs" *ngIf="profile.isAdmin || profile.IsSuperUser">
              <span class="fa fa-fw hubtiger-clubs"></span>{{ "general.cycle_club" | translate }}
            </li> -->
            <li routerLink="myprofile" (click)="dropMenuOpen = !dropMenuOpen">
              <span class="fa fa-fw hubtiger-profile"></span>{{ "general.my_profile" | translate }}
            </li>
            <li (click)="setPrinter()">
              <span class="fa fa-fw hubtiger-print"></span>{{ "general.printer_setup" | translate }}
            </li>
            <li (click)="logout()">
              <span class="fa fa-fw hubtiger-logout"></span>{{ "general.logout" | translate }}
            </li>
          </ul>
        </div>
      </div>
      <div class="header-icon" *ngIf="!isShopRideAdminOnly()"      
           (click)="openNotificationsMenu($event); posSyncStatusOpen = false; dropMenuOpen = false">
        <span class="badge">{{ notifications.length }}</span>
        <span class="fa hubtiger-no-notification" style="font-size: 28px;"
              [ngClass]="{'low-credits': credits < 50 && credits > 0, 'no-credits': credits <= 0}"></span>

      </div>
      <div class="header-icon" *ngIf="!isShopRideAdminOnly()" style="margin-right: -8px;"
           (click)="openSyncMenu($event); notificationOpen = false; dropMenuOpen = false">
        <span class="fa fa-refresh" style="font-size: 21px"></span>

      </div>

      <div #notificationsMenuRef class="notification">
        <div class="menu-drop-down" [ngClass]="{ 'drop-menu-open': !notificationOpen }">
          <div class="notification-header">
            <div>{{ "general.notifications" | translate }}</div>
            <div>
              <span *ngIf="!isConnectedToTextPlatform">{{ "general.sms_credits" | translate }}
                {{ credits | number: ".0-0" }}</span>
            </div>
          </div>
          <div  class="no-bundles" *ngIf="credits <= 0 && !isConnectedToTextPlatform" routerLink="/store/purchase-messaging-bundle"
               (click)="notificationOpen = false;">{{'general.no_bundles' | translate}}</div>
          <div class="no-messages" *ngIf="notifications.length == 0">
            {{ "general.no_incoming_notifications" | translate }}
          </div>
          <ul>
            <li *ngFor="let notification of notifications">
              <div style="display: flex;">
                <div class="icon-area" (click)="actionMessage(notification)">
                  <span></span>
                </div>
                <div class="message-area" (click)="actionMessage(notification)">
                  <div class="message">{{ notification.Message }}</div>
                  <div class="sub-message">
                    #{{ notification.JobCardNo }} - {{ notification.User }}
                  </div>
                  <div class="date">
                    <span
                      class="hubtiger-calendar"></span>{{ notification.CreatedDate | date: countryData.AngularDateFormat + ' h:mm a' }}
                  </div>
                </div>
                <div style="display: flex;">
                  <span class="hubtiger-close close" (click)="dismissMessage(notification)"></span>
                </div>
              </div>
            </li>
          </ul>
          <div class="notifications-footer">
            <!-- <div class="all-notifications" (click)="openAllNotifications()">{{ 'general.see_all_incoming_notifications' | translate }}</div> -->
            <button pButton type="button" class="p-button-raised outline red"
                    label="{{ 'general.see_all_incoming_notifications' | translate }}"
                    (click)="openAllNotifications()"></button>
            <div class="margin-top-8" *ngIf="canSubscribeToNotifications">
              <button pButton type="button" class="p-button-raised outline green"
                      label="{{ 'general.subscribe_push_notifications' | translate }}"
                      (click)="subscribeToPushNotifications()" *ngIf="!hasActiveSubscription"></button>
              <button pButton type="button" class="p-button-raised outline red"
                      label="{{ 'general.unsubscribe_push_notifications' | translate }}"
                      (click)="unsubscribeFromPushNotifications()" *ngIf="hasActiveSubscription"></button>
            </div>
          </div>
        </div>
      </div>

      <div #posSyncStatusOpenRef class="pos-sync-summary">
        <div class="menu-drop-down" [ngClass]="{ 'drop-menu-open': !posSyncStatusOpen }">
          <div *ngIf="posSyncStatusOpen">
            <app-pos-sync-status></app-pos-sync-status>
          </div>
        </div>
      </div>


      <div class="header-icon whats-new">
        <div class="beamer">New Features</div>
      </div>
    </div>
  </div>
  <div class="hub-sidebar active" [ngClass]="{ 'close-menu': !menuOpen, shadowDown: showShadow }">
    <div class="hub-navbutton">
      <i class="fa hubtiger-close" (click)="menuOpen = !menuOpen" [ngClass]="{ rotate: !menuOpen }"></i>
    </div>
    <div class="hub-navlogo">
      <img src="../../../../assets/hubtiger_logo_full.png"/>
    </div>
    <div class="white-label-container">
      <div class="white-label-logo">
        <br>
      </div>
    </div>

    <div class="product-picker" *ngIf="showProductPicker">
      <div (click)="activateWorkshop()" class="main-menu-toggle" [ngClass]="{'active': activeProduct==='WORKSHOP'}">{{'bikeshop.menu.workshop' | translate }}</div>
      <div (click)="activateRentals()" class="main-menu-toggle" [ngClass]="{'active': activeProduct==='RENTALS'}">{{ 'bikeshop.shop_setup.header.rentals' | translate }}</div>
    </div>
    <div class="menu-container main-side-menu">
      <!--      <p-menu [model]="menuItems"></p-menu>-->
      <p-menu [model]="menuItems">
        <ng-template pTemplate="item" let-item class="main-menu-item">
          <a class="p-menuitem-link flex align-items-center p-3" [routerLink]="item.routerLink"
             [routerLinkActive]="'p-menuitem-link-active'">

            <span class="menu-icon"><daz-icon [name]="item.icon" [size]="'26px'"
                                              [color]="'var(--hubtiger-contrast)'"></daz-icon></span>
            <span class="menu-label ml-2"> {{ item.label }}<span *ngIf="item.showServiceIndicatorsDue" class="menu-badge">{{item.serviceIndicatorsDue}}</span></span>
            <!--            <span class="arrow-right"><daz-icon [name]="'arrow-right'" [size]="'24px'"-->
            <!--                                                [color]="'var(&#45;&#45;hubtiger-negative)'"></daz-icon></span>-->

          </a>


        </ng-template>


      </p-menu>


      <div class="select-store-menu" [ngClass]="{ 'close-menu': !menuOpen}">
        <!--        <div class="extra-menu-link" (click)="openHelpVideos()">-->
        <!--          <p>Help Videos</p>-->
        <!--        </div>-->
        <span *ngIf="shopDropMenuOpenNew">
                        <div style="margin-top: 16px;" class="menu-drop-down shop-menu-drop-down">
                          <ul>
                              <li *ngFor="let shop of shops" (click)="selectShop(shop)">
                              <span class="shop-name">{{shop.Name}}</span><span
                                *ngIf="checkProfileShop(shop.ID)">

                              <daz-icon class="selected-store-icon"
                                        [name]="'check'"
                                        [size]="'24px'"
                                        [color]="'var(--hubtiger-secondary)'"></daz-icon>

                            </span>
                            </li>

                          </ul>
                        </div>

                  </span>
        <div #menuOpenLink class="p-menuitem-link select-store-button" *ngIf="userOfShops > 1"
             [ngClass]="{'no-product-pick' : !showProductPicker}"
             (click)="shopDropMenuOpenNew = !shopDropMenuOpenNew">
             <span><daz-icon class="select-store-icon" [name]="'arrow-up'" [color]="'var(--hubtiger-contrast)'"></daz-icon></span>
             <span class="store-button-text">{{ partner.Name }}</span>
        </div>

        <!--<div class="p-menuitem-link help-video-button"
             [ngClass]="{'no-product-pick' : !showProductPicker}"
             (click)="openReferrals()"><span
          class="help-text ml-4">{{'general.refer_and_earn' | translate}}</span>
          <span><daz-icon class="select-store-icon"
                          [name]="'message-heart'"
                          [size]="'24px'"
                          [color]="'var(--hubtiger-contrast)'"></daz-icon></span></div>-->


        <!--<div class="p-menuitem-link help-video-button"
             (click)="helpSubMenu = !helpSubMenu"><span
          class="help-text ml-4">{{'general.help' | translate }}</span>
          <span><daz-icon class="select-store-icon"
                          [name]="'play'"
                          [size]="'24px'"
                          [color]="'var(--hubtiger-contrast)'"></daz-icon></span></div>-->

        <div class="submenu" *ngIf="helpSubMenu"  (mouseleave)="helpSubMenu = false">
          <div class="submenu-item" (click)="openHelpVideos()">
            <p> {{'general.help_videos' | translate }}</p>
          </div>
          <div (click)="openHelpDesk()" class="submenu-item" >
            <p> {{'general.live_chat' | translate }}</p>
          </div>
        </div>


<!--        <div class="p-menuitem-link help-video-button"-->
<!--             (click)="openHelpVideos()"><span-->
<!--          class="help-text ml-4">{{'general.help_videos' | translate }}</span>-->
<!--          <span><daz-icon class="select-store-icon"-->
<!--                          [name]="'play'"-->
<!--                          [size]="'24px'"-->
<!--                          [color]="'var(&#45;&#45;hubtiger-contrast)'"></daz-icon></span></div>-->


      </div>

    </div>
    <!--    <div class="menu-container">-->
    <!--      <p-menu [model]="menuItems"></p-menu>-->
    <!--      &lt;!&ndash; <p-panelMenu-->
    <!--        [transitionOptions]="'400ms'"-->
    <!--        [model]="menuItems"-->
    <!--        [multiple]="false"-->
    <!--        *ngIf="profile.isAdmin"-->
    <!--      >-->
    <!--      </p-panelMenu> &ndash;&gt;-->
    <!--    </div>-->
  </div>
  <div class="hub-content" [ngClass]="{ 'close-menu-content': !menuOpen }">
    <div class="portal-payment-alert"
         *ngIf="!hidePaymentAlert && showPaymentStatusWarning() && paymentStatus.message">
      <div>{{paymentStatus.message}} <a [routerLink]="getSubscriptionURL()">{{paymentStatus.secondaryMessage}}</a>
      </div>
      <span class="hubtiger-close" (click)="hidePaymentAlert=true"></span>
    </div>
    <div class="hub-content-background"></div>
    <div *ngIf="profileDataLoaded" style="position: relative;">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<p-toast position="bottom-center" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog key="bikeshop_main" rejectIcon="" acceptIcon=""></p-confirmDialog>

<p-toast position="center" key="global_toast" (onClose)="onReject()" styleClass="hubtiger-toast-modal">
  <ng-template let-message pTemplate="message">
    <div style="text-align: center">
      <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
      <h3>{{message.summary}}</h3>
      <p>{{message.detail}}</p>
    </div>
    <div class="row">
      <div class="col-md-6">
        <button type="button" pButton (click)="onConfirm()" label="Yes" class="full-width"></button>
      </div>
      <div class="col-md-6">
        <button type="button" pButton (click)="onReject()" label="No" class="full-width"></button>
      </div>
    </div>
  </ng-template>
</p-toast>

<p-sidebar #NavSideBar [(visible)]="showRentalReservation" position="right"
  [autoZIndex]="false"
  [style]="{width:'950px', background: '#FAFAFA', 'overflow-x': 'auto','z-index': '1001'}"  (onHide)="NavSideBar.destroyModal()">
  <div *ngIf="showRentalReservation">
    <app-rental-reservation-update [reservationSummary]="selectedReservation"
                                   [categories]="[]" [brands]="[]" [sizes]="[]"
                                   [rentalStoreRules]="{}"></app-rental-reservation-update>
  </div>
</p-sidebar>

<app-workshop-active-jobcard-timers *ngIf="activeProduct === 'WORKSHOP'"></app-workshop-active-jobcard-timers>
<!--<app-help-request></app-help-request>-->
